@for (notification of notifications; track $index) {
<div class="notification" [class]="notification.type" [class.dismissed]="notification.isDismissed">
    <div class="notification-icon">
        <mat-icon>{{getNotificationIcon(notification)}}</mat-icon>
    </div>
    <div class="notification-message" [innerHTML]="notification.message"></div>
    <div class="notification-close" (click)="closeNotification(notification)"><mat-icon>close</mat-icon></div>
</div>
}
